import {
    Button,
    colors,
    Grid,
    IconButton,
    Input,
    InputAdornment,
    Paper,
    Typography,
    withStyles,
    Box
} from '@material-ui/core';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import FormatSizeIcon from '@material-ui/icons/FormatSize';
import SendIcon from '@material-ui/icons/Send';
import DraftsIcon from '@material-ui/icons/Drafts';
import Moment from 'moment/moment';
import join from 'url-join';
import React, { Component } from 'react';
import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { WsUrl } from '../../config.json';
import { sendMessage2ServiceWorker } from '../../util/service_worker';
import { ApiServerUrl } from '../../config.json';
import { withLang } from '../../util/lang';
import '../../util/string';
import DragAndDrop from '../NewPatient/Photos/DragAndDrop';
import style from './chat.module.css';
import { easySnackbar } from '../../store/Noti/noti.actions';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import PropTypes from 'prop-types';
import ChatIcon from '@material-ui/icons/Chat';

import AssessmentIcon from '@material-ui/icons/Assessment';
import LockIcon from '@material-ui/icons/Lock';
import CollectionsBookmarkIcon from '@material-ui/icons/CollectionsBookmark';
import Tooltip from '@material-ui/core/Tooltip';
import Badge from '@material-ui/core/Badge';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import CircularProgress from '@material-ui/core/CircularProgress';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import { MdOpenInNewOff } from 'react-icons/md';
import VerticalSplitIcon from '@material-ui/icons/VerticalSplit';
import PanToolIcon from '@material-ui/icons/PanTool';
import FullscreenIcon from '@material-ui/icons/Fullscreen';
import FullscreenExitIcon from '@material-ui/icons/FullscreenExit';
import BurstModeIcon from '@material-ui/icons/BurstMode';
import { getWebAbsPath } from '../../util/path';
import { smileDesignProductListArray } from '../../store/SmileDesign/SmileDesignSlice';
import _ from 'lodash';
import { ERROR } from '../../util/const';
import { openModal } from '../../store/Global/global';
import {
    CHAT_TYPE,
    resetDeletableMsgMap,
    setDeletableMsgMap,
    setDraftChatMessage,
} from '../../store/ClinicalSimulation/clinicalSimulation';

const role = JSON.parse(localStorage.getItem('role'));

const DELETE_MSG_TIME_LIMIT_FOR_DR = 5 * 60 * 1000; // 5 minutes in milliseconds

const DELETE_MSG_TIME_LIMIT_FOR_ADMIN = 60 * 4 * 60 * 1000; // 4 hours in milliseconds

const styles = (theme) => ({
    root: {
        backgroundColor: theme.palette.background.paper,
        width: '100%',
    },
    chatBase: {
        padding: '8px 12px',
        borderRadius: '5px',
        color: 'white',
        width: 'fit-content',
        maxWidth: '70%',
        margin: '8px 0px',
    },
    image: {
        backgroundColor: '#e6e6e6',
    },
    system: {
        backgroundColor: 'black',
    },
    chatBgOther: {
        backgroundColor: '#9c9c9c !important',
    },
    chatBgSelf: {
        backgroundColor: '#504575 !important',
    },
    progress: {
        margin: theme.spacing.unit * 2,
    },
    hideTabs: {
        display: 'none',
    },
    exitFullScreen: {
        display: 'none',
    },
    notFullScreen: {
        flex: '1 1 auto',
        minHeight: 0,
        display: 'flex',
        flexDirection: 'column',
    },
    positioned: {
        position: 'absolute',
        top: '0%',
        right: '30px',
        minWidth: '433px',
        backgroundColor: '#fff',
        border: '2px dashed lightgray',
    },
});

function TabContainer(props) {
    return <Typography component="div" style={{ height: '100%', display: '100%', display: 'flex', flexDirection: 'column' }}>{props.children}</Typography>;
}

function TabContainerC(props) {
    return <Tab {...props} style={{ minWidth: '40px', fontSize: '0.7rem' }} />;
}

TabContainer.propTypes = {
    children: PropTypes.node.isRequired,
};

class Chat extends Component {
    constructor(props) {
        super(props);
        this.state = {
            chatRoom: this.props.chatType || 0,
            message: '',
            messages: [],
            chatRoomMessags: [],
            privateChatMessages: [],
            intlChatMessages: [],
            response: '',
            textFontSize: 'small',
            allMessages: [],
            loadingMessages: true,
            privateMessage: false,
            unreadMessageCount: 0,
            chatRoomUnreadMessagsCount: 0,
            privateChatUnreadMessagesCount: 0,
            intlChatUnreadMessagesCount: 0,
            opendMarkReadConfirm: false,
            currentUserId: parseInt(JSON.parse(localStorage.getItem('auth-token'))),
            currentDistrGroupId: parseInt(JSON.parse(localStorage.getItem('distr_group_id'))),
            currentAdminGroupId: parseInt(JSON.parse(localStorage.getItem('admin_group_id'))),
            currentUserRole: JSON.parse(localStorage.getItem('role')),
            lastSeen: undefined,
            privateLastSeen: undefined,
            intlLastSeen: undefined,
            currentTreatmentPlan: this.props.currentTreatmentPlan,
            isShowSmileDesignFeature: false,
            patientInfoData: null,
        };
        this.isStopped = false;
        this.retryCount = 0;
        this.heartbeatTimer = null;
        this.msgContainer = React.createRef();
        this.setMessage = this.setMessage.bind(this);
        this.handleDrop = this.handleDrop.bind(this);
        this.markAsRead = _.debounce(this.markAsRead.bind(this), 2000, { leading: true, trailing: false });
        this.handleOnPaste = this.handleOnPaste.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    changeFontSize() {
        let fontSizes = ['small', 'medium', 'large'];
        let currentSize = fontSizes.indexOf(this.state.textFontSize);
        currentSize == 2
            ? this.setState({ textFontSize: fontSizes[0] })
            : this.setState({ textFontSize: fontSizes[currentSize + 1] });
    }

    setPatientInfoData() {
        const { patientInfoData } = this.props?.clinicalSimulation;
        const isEqual = _.isEqual(this.state.patientInfoData, patientInfoData);
        if (!isEqual) {
            this.setState({ patientInfoData: patientInfoData });
            const isShowSmileDesignFeature =
                ['SIMPLE', ...smileDesignProductListArray].includes(patientInfoData.case_type) &&
                patientInfoData.isSmileDesign;
            this.setState({ isShowSmileDesignFeature });
        }
    }

    loadDraftMessageToInput() {
        const { draftChatMsg, draftPrivateChatMsg, draftIntlChatMsg } = this.props?.clinicalSimulation;
        const room = this.state.chatRoom;

        switch (room) {
            case CHAT_TYPE.privatechat:
                if (draftPrivateChatMsg && draftPrivateChatMsg?.length > 0) {
                    this.setState({ message: draftPrivateChatMsg });
                }
                break;
            case CHAT_TYPE.intlchat:
                if (draftIntlChatMsg && draftIntlChatMsg?.length > 0) {
                    this.setState({ message: draftIntlChatMsg });
                }
                break;
            default:
                if (draftChatMsg && draftChatMsg?.length > 0) {
                    this.setState({ message: draftChatMsg });
                }
        }
    }

    async componentDidMount() {
        this.url = join(WsUrl, this.props.caseId.toString());
        this.socket = new WebSocket(this.url);
        this.setupWebsocket(this.socket);

        window.addEventListener('focus', this.onFocus);
        window.addEventListener('blur', this.onBlur);

        if (navigator.serviceWorker && navigator.serviceWorker.controller) {
            navigator.serviceWorker.addEventListener('message', this.onServiceWorkerMessage);
            navigator.serviceWorker.controller.postMessage({
                type: 'load',
                case_id: parseInt(this.props.caseId),
            });
        }
        this.setPatientInfoData();
        this.loadDraftMessageToInput();
    }

    componentWillUnmount() {
        this.isStopped = true;
        this.props.clearDeletableMsgMap();
        this.markAsRead.cancel();
    }

    onFocus = (_) => {
        sendMessage2ServiceWorker({
            type: 'focus',
            case_id: parseInt(this.props.caseId),
        });
    };

    onBlur = (_) => {
        sendMessage2ServiceWorker({
            type: 'blur',
            case_id: parseInt(this.props.caseId),
        });
    };

    async componentWillMount() {
        if (navigator.serviceWorker) {
            navigator.serviceWorker.removeEventListener('message', this.onServiceWorkerMessage);
            sendMessage2ServiceWorker({
                type: 'unload',
                case_id: parseInt(this.props.caseId),
            });
            window.removeEventListener('focus', this.onFocus);
            window.removeEventListener('blur', this.onBlur);
        }
    }

    onServiceWorkerMessage = (event) => {
        console.log('From service worker: ', event.data);
    };

    getIsChatMessageDeletable = (sent_date) => {
        if (!sent_date) return false;
        let timeLimit = DELETE_MSG_TIME_LIMIT_FOR_ADMIN;
        if (role === 'DR') {
            timeLimit = DELETE_MSG_TIME_LIMIT_FOR_DR;
        }
        return Date.now() - new Date(sent_date).getTime() <= timeLimit;
    };

    removeChatIdInDeletableMap(chatId = 0) {
        if (!chatId) return;
        const { deletableMsgMap } = this.props.clinicalSimulation;
        if (!deletableMsgMap.has(chatId)) return;
        // new map for new address reference to tirgger re-render,
        // and to avoid unexpected behavior modifying the map when looping
        const updatedDeletableMap = new Map(deletableMsgMap);
        deletableMsgMap.forEach((value, key) => {
            if (key === chatId) {
                updatedDeletableMap.delete(key);
            } else if (!this.getIsChatMessageDeletable(value)) {
                updatedDeletableMap.delete(key);
            }
        });
        this.props.updateDeletableMsgMap(updatedDeletableMap);
    }
    setupWebsocket(socket) {
        if (++this.retryCount > 50) {
            this.props.enqueueSnackbar('Chatroom disconnected. Please try again later', 'error');
            return;
        }
        socket.onerror = (err) => {
            console.error(err);
            if (this.heartbeatTime) {
                clearInterval(this.heartbeatTime);
            }
            if (![socket.CONNECTING, socket.OPEN].includes(socket.readyState)) {
                this.setState({ loadingMessages: true });
                if (!this.retryTimer) {
                    this.retryTimer = setTimeout(() => {
                        try {
                            this.socket.onclose = this.socket.onerror = this.socket.onmessage = null;
                            this.socket.close();
                        } finally {
                        }
                        if (!this.isStopped) {
                            let socket = new WebSocket(this.url);
                            this.setupWebsocket(socket);
                            this.socket = socket;
                            this.retryTimer = null;
                        }
                    }, 5000);
                }
            }
        };

        socket.onopen = () => {
            console.info('connected');
            if (this.heartbeatTimer) {
                clearInterval(this.heartbeatTimer);
            }
            this.heartbeatTimer = setInterval(() => this.socket.send(JSON.stringify({ type: 'PING' })), 10000);
        };

        socket.onmessage = function ({ data: dataStr }) {
            this.setState({ loadingMessages: false });
            let data = JSON.parse(dataStr);
            if (data.success) {
                this.updateMsg(data.chat);
            } else {
                console.error(data.message);
                if (data.message && data.message.length > 0) {
                    if (data.message.startsWith(ERROR.FAILED_TO_DELETE_CHAT_MESSAGE_CID)) {
                        const chatId = data.message.split(':')[1];
                        const msgTranslationKey = data.message.split(':')[0];
                        const chatInt = parseInt(chatId);
                        this.removeChatIdInDeletableMap(chatInt);
                        this.props.openModal({
                            message: this.get(
                                `clinicalSimulation.msg.${msgTranslationKey || ERROR.FAILED_TO_DELETE_CHAT_MESSAGE_CID}`
                            ),
                            showOk: false,
                        });
                    }
                }
            }
        }.bind(this);

        socket.onclose = () => {
            console.info('disconnected');
            if (this.heartbeatTime) {
                clearInterval(this.heartbeatTime);
            }
            if (![socket.CONNECTING, socket.OPEN].includes(socket.readyState)) {
                this.setState({ loadingMessages: true });
                if (!this.retryTimer) {
                    this.retryTimer = setTimeout(() => {
                        try {
                            this.socket.onclose = this.socket.onerror = this.socket.onmessage = null;
                            this.socket.close();
                        } finally {
                        }
                        if (!this.isStopped) {
                            let socket = new WebSocket(this.url);
                            this.setupWebsocket(socket);
                            this.socket = socket;
                            this.retryTimer = null;
                        }
                    }, 5000);
                }
            }
        };
    }

    updateMsg(incomingMsgs) {
        incomingMsgs = Array.ensureArray(incomingMsgs);
        const { msgs, deletedChatIds } = incomingMsgs.reduce(
            ({ msgs, deletedChatIds }, msg) => {
                if (msg.type === 'DELETE') {
                    deletedChatIds.push(parseInt(msg.data));
                } else {
                    msgs.push(msg);
                }
                return { msgs, deletedChatIds };
            },
            { msgs: [], deletedChatIds: [] }
        );
        let {
            allMessages,
            chatRoomMessags,
            privateChatMessages,
            intlChatMessages,
            chatRoomUnreadMessagsCount,
            privateChatUnreadMessagesCount,
            intlChatUnreadMessagesCount,
        } = this.state;
        if (deletedChatIds.length) {
            allMessages = allMessages.filter((msg) => !deletedChatIds.includes(parseInt(msg.chat_id)));
        }
        allMessages = allMessages.concat(msgs);
        [0, 3, 4].forEach((room) => {
            const curMsgs = msgs.filter((msg) => parseInt(msg.room) === parseInt(room) && msg.type !== 'SEEN');
            const lastSeen =
                msgs.reduce((lastSeen, msg) => {
                    if (parseInt(msg.room) === 3 || parseInt(msg.room) === 4) {
                        if (
                            msg.type === 'SEEN' &&
                            parseInt(msg.room) === room &&
                            parseInt(msg.user_id) === parseInt(this.state.currentUserId) &&
                            (!lastSeen || (msg.last_seen_date && new Date(msg.last_seen_date) > lastSeen))
                        ) {
                            return new Date(msg.last_seen_date);
                        }
                    } else if (parseInt(msg.room) === 0) {
                        if (
                            msg.type === 'SEEN' &&
                            parseInt(msg.room) === room &&
                            (parseInt(msg.user_id) === parseInt(this.state.currentUserId)) &&
                            (!lastSeen || (msg.last_seen_date && new Date(msg.last_seen_date) > lastSeen))
                        ) {
                            return new Date(msg.last_seen_date);
                        }
                    }
                    return lastSeen;
                }, undefined) ??
                (room === 3 ? this.state.privateLastSeen : room === 4 ? this.state.intlLastSeen : this.state.lastSeen);

            switch (room) {
                case 0: {
                    if (deletedChatIds.length) {
                        chatRoomMessags = chatRoomMessags.filter(
                            (msg) => !deletedChatIds.includes(parseInt(msg.chat_id))
                        );
                    }
                    chatRoomMessags = chatRoomMessags.concat(curMsgs);
                    if (lastSeen || deletedChatIds.length) {
                        chatRoomUnreadMessagsCount = chatRoomMessags.filter(
                            ({
                                type,
                                sender_id,
                                sender_distr_group_id,
                                sender_admin_group_id,
                                sent_date,
                                start_read_date,
                            }) =>
                                type !== 'SYSTEM' &&
                                parseInt(sender_id) !== parseInt(this.state.currentUserId) &&                               
                                (!lastSeen || new Date(sent_date) > lastSeen) &&
                                new Date(sent_date) > new Date(start_read_date)
                        ).length;
                    } else {
                        chatRoomUnreadMessagsCount += curMsgs.filter(
                            ({
                                type,
                                sender_id,
                                sender_distr_group_id,
                                sender_admin_group_id,
                                sent_date,
                                start_read_date,
                            }) =>
                                type !== 'SYSTEM' &&
                                parseInt(sender_id) !== parseInt(this.state.currentUserId) &&                               
                                new Date(sent_date) > new Date(start_read_date)
                        ).length;
                    }
                    this.setState({
                        allMessages,
                        chatRoomMessags,
                        chatRoomUnreadMessagsCount,
                        lastSeen,
                    });
                    break;
                }
                case 3: {
                    if (deletedChatIds.length) {
                        privateChatMessages = privateChatMessages.filter(
                            (msg) => !deletedChatIds.includes(parseInt(msg.chat_id))
                        );
                    }
                    privateChatMessages = privateChatMessages.concat(curMsgs);
                    if (lastSeen || deletedChatIds.length) {
                        privateChatUnreadMessagesCount = privateChatMessages.filter(
                            ({ type, sender_id, sent_date, start_read_date }) =>
                                type !== 'SYSTEM' &&
                                parseInt(sender_id) !== parseInt(this.state.currentUserId) &&
                                (!lastSeen || new Date(sent_date) > lastSeen) &&
                                new Date(sent_date) > new Date(start_read_date)
                        ).length;
                    } else {
                        privateChatUnreadMessagesCount += curMsgs.filter(
                            ({ type, sender_id, sent_date, start_read_date }) =>
                                type !== 'SYSTEM' &&
                                parseInt(sender_id) !== parseInt(this.state.currentUserId) &&
                                new Date(sent_date) > new Date(start_read_date)
                        ).length;
                    }
                    this.setState({
                        allMessages,
                        privateChatMessages,
                        privateChatUnreadMessagesCount,
                        privateLastSeen: lastSeen,
                    });
                    break;
                }
                case 4: {
                    if (deletedChatIds.length) {
                        intlChatMessages = intlChatMessages.filter(
                            (msg) => !deletedChatIds.includes(parseInt(msg.chat_id))
                        );
                    }
                    intlChatMessages = intlChatMessages.concat(curMsgs);
                    if (lastSeen || deletedChatIds.length) {
                        intlChatUnreadMessagesCount = intlChatMessages.filter(
                            ({ type, sender_id, sent_date, start_read_date }) =>
                                type !== 'SYSTEM' &&
                                parseInt(sender_id) !== parseInt(this.state.currentUserId) &&
                                (!lastSeen || new Date(sent_date) > lastSeen) &&
                                new Date(sent_date) > new Date(start_read_date)
                        ).length;
                    } else {
                        intlChatUnreadMessagesCount += curMsgs.filter(
                            ({ type, sender_id, sent_date, start_read_date }) =>
                                type !== 'SYSTEM' &&
                                parseInt(sender_id) !== parseInt(this.state.currentUserId) &&
                                new Date(sent_date) > new Date(start_read_date)
                        ).length;
                    }
                    this.setState({
                        allMessages,
                        intlChatMessages,
                        intlChatUnreadMessagesCount,
                        intlLastSeen: lastSeen,
                    });
                    break;
                }
            }
        });
    }

    markAsRead() {
        this.setState({ opendMarkReadConfirm: false });
        this.socket.send(
            JSON.stringify({
                type: 'SEEN',
                room: this.state.chatRoom,
                data: new Date(),
            })
        );
    }

    componentDidUpdate(prevProps) {
        this.setPatientInfoData();
        this.scrollToBottem();
    }
    handleOnPaste(event) {
        const items = event.clipboardData || event.originalEvent.clipboardData;

        this.fileupload(items.files[0]);
        return;
    }

    handleMsgInputKeypress(e) {
        let msg = this.state.message;

        if (e.key === 'Enter' && !e.shiftKey && msg.replace(/\s/g, '').length > 0) {
            e.preventDefault();
            this.setState({ message: '' });
            e.target.value = '';
            this.socket.send(
                JSON.stringify({
                    type: 'TEXT',
                    data: msg,
                    room: this.state.chatRoom,
                    isPrivate: this.state.privateMessage,
                    isIntl: this.state.intlMessage,
                })
            );
        }
    }

    handleSentButtonClick(e) {
        if (String.isNotBlank(this.state.message)) {
            let msg = this.state.message;
            this.setState({ message: '' });

            this.socket.send(
                JSON.stringify({
                    type: 'TEXT',
                    data: msg,
                    room: this.state.chatRoom,
                    isPrivate: this.state.privateMessage,
                    isIntl: this.state.intlMessage,
                })
            );
        }
    }

    fileToBase64 = (file) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            if (file !== undefined) {
                reader.readAsDataURL(file);
            }
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });

    async fileupload(file) {
        let ClassThis = this;
        const data = await this.fileToBase64(file);
        if (file.type.startsWith('image')) {
            ClassThis.socket.send(
                JSON.stringify({
                    type: 'IMAGE',
                    room: this.state.chatRoom,
                    data,
                })
            );
        } else {
            ClassThis.socket.send(
                JSON.stringify({
                    type: 'FILE',
                    room: this.state.chatRoom,
                    fileName: file.name,
                    data,
                })
            );
        }
    }

    handleDrop(uploadfile) {
        if (this.state.chatRoom === 0 && !['DR', 'NR', 'DISTR'].includes(this.state.currentUserRole)) {
            return;
        }
        this.fileupload(uploadfile);
    }

    setMessage(messagesList) {
        const { classes, clinicalSimulation } = this.props;
        const { deletableMsgMap } = clinicalSimulation;
        return messagesList
            .filter(
                (v) =>
                    v &&
                    v.type !== 'SEEN' &&
                    (v.type !== 'SYSTEM' || (v.data.type === 'STATUS' && v.data.status !== ''))
            )
            .map((msg, i) => {
                const isMsgDeleteable = msg.type !== 'SYSTEM' && this.getIsChatMessageDeletable(msg.sent_date);
                if (isMsgDeleteable && !deletableMsgMap.has(msg.chat_id)) {
                    const newDeletableMap = new Map(deletableMsgMap);
                    newDeletableMap.set(msg.chat_id, msg.sent_date);
                    this.props.updateDeletableMsgMap(newDeletableMap);
                }
                // if NOT myself and (message is text or image) or (message is status and not empty)
                if (
                    this.state.currentUserId !== msg.sender_id &&
                    !(['ADMIN', 'SADMIN', 'DISTR', 'DR'].includes(this.state.currentUserRole) && msg.type === 'SYSTEM')
                ) {
                    return (
                        <Grid item xs={12} key={i}>
                            <Paper
                                elevation={1}
                                className={['msgBody', classes.chatBase, classes.chatBgOther].join(' ')}
                                style={{
                                    textAlign: 'left',
                                    width: msg.type === 'IMAGE' ? '70%' : 'fit-content',
                                    fontSize: this.state.textFontSize,
                                }}
                            >
                                {msg.type === 'IMAGE' &&
                                    (['DISTR'].includes(this.state.currentUserRole) ||
                                        (['SADMIN', 'ADMIN'].includes(this.state.currentUserRole) &&
                                            parseInt(msg.room) === 0)) && (
                                        <>
                                            <Zoom zoomMargin={48}>
                                                <img src={join(ApiServerUrl, msg.data)} style={{ width: '100%' }} />
                                            </Zoom>
                                        </>
                                    )}
                                {msg.type === 'IMAGE' &&
                                    ['SADMIN', 'ADMIN'].includes(this.state.currentUserRole) &&
                                    (parseInt(msg.room) === 3 || parseInt(msg.room) === 4) && (
                                        <>
                                            <Zoom zoomMargin={48}>
                                                <img src={join(ApiServerUrl, msg.data)} style={{ width: '100%' }} />
                                            </Zoom>
                                        </>
                                    )}
                                {msg.type === 'IMAGE' &&
                                    !['SADMIN', 'ADMIN', 'DISTR'].includes(this.state.currentUserRole) && (
                                        <>
                                            <Zoom zoomMargin={48}>
                                                <img src={join(ApiServerUrl, msg.data)} style={{ width: '100%' }} />
                                            </Zoom>
                                        </>
                                    )}
                                {msg.type === 'TEXT' &&
                                    (['DISTR'].includes(this.state.currentUserRole) ||
                                        (['SADMIN', 'ADMIN'].includes(this.state.currentUserRole) &&
                                            parseInt(msg.room) === 0)) &&
                                    msg.data.split('\n').map((v) => <p key={v}>{v}</p>)}
                                {msg.type === 'TEXT' &&
                                    ['SADMIN', 'ADMIN'].includes(this.state.currentUserRole) &&
                                    (parseInt(msg.room) === 3 || parseInt(msg.room) === 4) &&
                                    msg.data.split('\n').map((v) => <p key={v}>{v}</p>)}
                                {msg.type === 'TEXT' &&
                                    !['SADMIN', 'ADMIN', 'DISTR'].includes(this.state.currentUserRole) &&
                                    msg.data.split('\n').map((v) => <p key={v}>{v}</p>)}

                                {msg.type === 'FILE' && (
                                    <a
                                        href={join(ApiServerUrl, `${msg.data}?fn=${msg.fileName}`)}
                                        style={{ color: 'white' }}
                                    >
                                        {msg.fileName}
                                    </a>
                                )}
                                {msg.type === 'SYSTEM' && (
                                    <p>{`${this.get('clinicalSimulation.chat.caseStatusChanged')}. ${this.get('clinicalSimulation.chat.newStatus')}: ${msg.data.status} (system)`}</p>
                                )}
                            </Paper>

                            <div style={{ display: 'inline-flex' }}>
                                <Typography
                                    variant="body1"
                                    component="p"
                                    style={{ textAlign: 'left', margin: '4px', fontSize: 12, color: 'grey' }}
                                >
                                    {msg.sender} {Moment(msg.sent_date).format('YYYY-MM-DD HH:mm')}
                                </Typography>
                            </div>
                        </Grid>
                    );
                }
                //if myself and (message is text or image) or (message is status and not empty)
                else if (
                    this.state.currentUserId === msg.sender_id &&
                    !(['ADMIN', 'SADMIN', 'DISTR', 'DR'].includes(this.state.currentUserRole) && msg.type === 'SYSTEM')
                ) {
                    return (
                        <Grid item xs={12} align="right" key={i}>
                            <Paper
                                elevation={1}
                                className={['msgBody', classes.chatBase, classes.chatBgSelf].join(' ')}
                                style={{
                                    textAlign: 'left',
                                    fontSize: this.state.textFontSize,
                                }}
                            >
                                {msg.type === 'IMAGE' &&
                                    (['DISTR'].includes(this.state.currentUserRole) ||
                                        (['SADMIN', 'ADMIN'].includes(this.state.currentUserRole) &&
                                            parseInt(msg.room) === 0)) && (
                                        <>
                                            <Zoom zoomMargin={48}>
                                                <img src={join(ApiServerUrl, msg.data)} style={{ width: '100%' }} />
                                            </Zoom>
                                        </>
                                    )}
                                {msg.type === 'IMAGE' &&
                                    ['SADMIN', 'ADMIN'].includes(this.state.currentUserRole) &&
                                    (parseInt(msg.room) === 3 || parseInt(msg.room) === 4) && (
                                        <>
                                            <Zoom zoomMargin={48}>
                                                <img src={join(ApiServerUrl, msg.data)} style={{ width: '100%' }} />
                                            </Zoom>
                                        </>
                                    )}
                                {msg.type === 'IMAGE' &&
                                    !['SADMIN', 'ADMIN', 'DISTR'].includes(this.state.currentUserRole) && (
                                        <>
                                            <Zoom zoomMargin={48}>
                                                <img src={join(ApiServerUrl, msg.data)} style={{ width: '100%' }} />
                                            </Zoom>
                                        </>
                                    )}
                                {msg.type === 'TEXT' &&
                                    (['DISTR'].includes(this.state.currentUserRole) ||
                                        (['SADMIN', 'ADMIN'].includes(this.state.currentUserRole) &&
                                            parseInt(msg.room) === 0)) &&
                                    msg.data.split('\n').map((v) => <p key={v}>{v}</p>)}
                                {msg.type === 'TEXT' &&
                                    ['SADMIN', 'ADMIN'].includes(this.state.currentUserRole) &&
                                    (parseInt(msg.room) === 3 || parseInt(msg.room) === 4) &&
                                    msg.data.split('\n').map((v) => <p key={v}>{v}</p>)}
                                {msg.type === 'TEXT' &&
                                    !['SADMIN', 'ADMIN', 'DISTR'].includes(this.state.currentUserRole) &&
                                    msg.data.split('\n').map((v) => <p key={v}>{v}</p>)}
                                {msg.type === 'FILE' && (
                                    <a
                                        href={join(ApiServerUrl, `${msg.data}?fn=${msg.fileName}`)}
                                        style={{ color: 'white' }}
                                    >
                                        {msg.fileName}
                                    </a>
                                )}
                                {msg.type === 'SYSTEM' && (
                                    <p>{`${this.get('clinicalSimulation.chat.caseStatusChanged')}. ${this.get('clinicalSimulation.chat.newStatus')}: ${msg.data.status} (system)`}</p>
                                )}
                            </Paper>
                            <div style={{ display: 'inline-flex' }}>
                                <Typography
                                    variant="body1"
                                    component="p"
                                    style={{ textAlign: 'right', margin: '4px', fontSize: 12, color: 'grey' }}
                                >
                                    {msg.sender} {Moment(msg.sent_date).format('YYYY-MM-DD HH:mm')}
                                </Typography>
                                {this.props.clinicalSimulation.deletableMsgMap.has(msg.chat_id) && (
                                    <DeleteOutlineIcon
                                        style={{ color: 'red', cursor: 'pointer' }}
                                        fontSize="small"
                                        onClick={() => {
                                            this.socket.send(
                                                JSON.stringify({
                                                    type: 'DELETE',
                                                    room: this.state.chatRoom,
                                                    data: msg.chat_id,
                                                })
                                            );
                                        }}
                                    />
                                )}
                            </div>
                        </Grid>
                    );
                }
            });
    }

    createMarkAsRead(unReadCount) {
        return (
            <>
                <IconButton style={{ height: 'fit-content', padding: '6px' }} onClick={() => this.handleClickOpen()}>
                    <Tooltip title="Mark as Read" placement="top">
                        <Badge className={style.customBadge} badgeContent={unReadCount}>
                            <DraftsIcon style={{ fontSize: 22 }}></DraftsIcon>
                        </Badge>
                    </Tooltip>
                </IconButton>
                <Dialog open={this.state.opendMarkReadConfirm} onClose={this.handleClose}>
                    <DialogContent>
                        <DialogContentText>Confirm marking read for chatroom's messages?</DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleClose}>No</Button>
                        <Button onClick={this.markAsRead}>Yes</Button>
                    </DialogActions>
                </Dialog>
            </>
        );
    }

    scrollToBottem() {
        if (this.msgContainer.current) {
            this.msgContainer.current.scrollTop = this.msgContainer.current.scrollHeight;
        } else {
            setTimeout(this.scrollToBottem.bind(this), 1000);
        }
    }

    handleClickOpen = () => {
        this.setState({ opendMarkReadConfirm: true });
    };
    handleClose = () => {
        this.setState({ opendMarkReadConfirm: false });
    };
    handleChange = (event, chatRoom) => {
        this.setState({ chatRoom }); //, () => this.reloadChatroom(chatRoom));
    };
    LoadDistributorChat = () => {
        // First create ChatRoom
        this.props.handleNewChatRoom();
        // Reload
        this.handleChange(undefined, this.props.chatType || 3);
    };
    smileDesignChatBoxHeight = (hideTabs) => {
        if (hideTabs) {
            return 'calc(100vh - 339px)';
        }
        return 'calc(100vh - 394px)';
    };

    // gridMdConditionFromOldCode = (hideSimulation, hideTabs) => {
    //     let value;
    //     if (hideSimulation) {
    //         value = 12;
    //     } else if (hideTabs && role === 'DISTR') {
    //         value = 6;
    //     } else if (hideTabs && (role === 'ADMIN' || role === 'SADMIN')) {
    //         value = 4;
    //     } else if (role === 'DR') {
    //         value = 12;
    //     } else {
    //         value = 12;
    //     }

    //     return value;
    // };
    gridMdConditionFromOldCode = (hideSimulation, hideTabs) => {
        let value;
        if (hideSimulation) {
            value = 12;
        } else if (hideTabs && role === 'DISTR') {
            value = 12;
        } else if (hideTabs && (role === 'ADMIN' || role === 'SADMIN')) {
            value = 12;
        } else if (role === 'DR') {
            value = 12;
        } else {
            value = 12;
        }
        return value;
    };


    render() {
        const {
            classes,
            hideTabs,
            dragPosition,
            hideSimulation,
            chatRomWidth,
            handleVerticalSplit,
            exitFullScreen,
            dragableChatRoom,
            handleFullScreen,
        } = this.props;
        const { chatRoom } = this.state;
        const isDoctorOrNurse = ['DR', 'NR'].includes(this.state.currentUserRole)
        return (
            <Grid
                item
                xs={12}
                md={this.gridMdConditionFromOldCode(hideSimulation, hideTabs)}
                className={dragPosition ? classes.positioned : ''}
            >
                <div className="chatboxWrap" style={{ display: 'flex', flexDirection: 'column', height: '99%' }}>
                    {/* {!dragPosition ? (
                        <Link
                            to={`/patients/${this.props.caseId}/treatment`}
                            target="_blank"
                            style={{ textDecoration: 'none' }}
                        >
                            <Button
                                className="treatmentplan"
                                style={{
                                    backgroundColor: '#445994',
                                    color: 'white',
                                    borderRadius: 0,
                                }}
                            >
                                {this.get('case_info.documentsList.viewTreatmentPlan')}
                            </Button>
                        </Link>
                    ) : null} */}
                    <div
                        className="caseIDWrap"
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            height: '50px',
                        }}
                    >
                        <Link
                            to={`/patients/${this.props.caseId}/treatment`}
                            target="_blank"
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                textDecoration: 'none',
                                flexGrow: '1',
                                color: 'inherit',
                            }}
                        >
                            <img src={getWebAbsPath('/img/front_smile.png')} width="48" />
                            <p>
                                {this.get(':fields.caseId')}: {this.props.caseId}{' '}
                                <span>
                                    {this.get('breadcrumbs.patient')}:{' '}
                                    {!!this.state.patientInfoData &&
                                        `${this.state.patientInfoData.first_name} ${this.state.patientInfoData.last_name}`}
                                </span>
                            </p>
                        </Link>

                        {/* here */}

                        {['ADMIN', 'SADMIN'].includes(this.state.currentUserRole) ? (
                            <div>
                                {!hideTabs && (
                                    <IconButton onClick={() => this.LoadDistributorChat()}>
                                        <OpenInNewIcon />
                                    </IconButton>
                                )
                                }
                                {/* Vertical Split: set 50% widths to chatRooms, show when md=4*3 */}
                                {/* {hideTabs && chatRoom === 4 && !hideSimulation ? (
                                    <>
                                        <IconButton onClick={() => handleVerticalSplit()}>
                                            <VerticalSplitIcon />
                                        </IconButton>
                                        <IconButton onClick={() => this.props.handleSmallChatRoom()}>
                                            <MdOpenInNewOff />
                                        </IconButton>
                                    </>
                                ) : (
                                    ''
                                )}
                                {hideTabs && chatRoom === 4 && hideSimulation ? (
                                    <>
                                        <IconButton onClick={() => handleVerticalSplit()}>
                                            <BurstModeIcon />
                                        </IconButton>
                                        <IconButton onClick={() => this.props.handleSmallChatRoom()}>
                                            <MdOpenInNewOff />
                                        </IconButton>
                                    </>
                                ) : (
                                    ''
                                )} */}
                                {hideTabs && chatRoom === 0 ? (
                                    <>
                                        <IconButton onClick={() => this.props.handleSmallChatRoom()}>
                                            <MdOpenInNewOff />
                                        </IconButton>
                                    </>
                                ) : (
                                    ''
                                )}
                            </div>
                        ) : (
                            ''
                        )}
                        {['DISTR'].includes(this.state.currentUserRole) ? (
                            <div>
                                {!hideTabs ? (
                                    <IconButton onClick={() => this.LoadDistributorChat()}>
                                        <OpenInNewIcon />
                                    </IconButton>
                                ) : (
                                    ''
                                )}
                                {/* Vertical Split: set 50% widths to chatRooms, show when md=4*3 */}
                                {hideTabs && chatRoom === 3 && !hideSimulation ? (
                                    <>
                                        <IconButton onClick={() => handleVerticalSplit()}>
                                            <VerticalSplitIcon />
                                        </IconButton>
                                        <IconButton onClick={() => this.props.handleSmallChatRoom()}>
                                            <MdOpenInNewOff />
                                        </IconButton>
                                    </>
                                ) : (
                                    ''
                                )}
                                {hideTabs && chatRoom === 3 && hideSimulation ? (
                                    <>
                                        <IconButton onClick={() => handleVerticalSplit()}>
                                            <BurstModeIcon />
                                        </IconButton>
                                        <IconButton onClick={() => this.props.handleSmallChatRoom()}>
                                            <MdOpenInNewOff />
                                        </IconButton>
                                    </>
                                ) : (
                                    ''
                                )}
                            </div>
                        ) : (
                            ''
                        )}
                        {isDoctorOrNurse ? (
                            <div>
                                {/* <IconButton onClick={() => dragableChatRoom()}>
                                    <PanToolIcon />
                                </IconButton> */}
                                <IconButton onClick={() => handleFullScreen()}>
                                    {!exitFullScreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
                                </IconButton>
                            </div>
                        ) : (
                            ''
                        )}
                    </div>
                    {/* Tabs */}
                    <div className={`${classes.root} ${exitFullScreen ? classes.exitFullScreen : classes.notFullScreen}`}>
                    <AppBar
                        position="static"
                        style={{
                            boxShadow: 'none',
                            border: '0',
                            borderTop: '1px',
                            borderBottom: '1px',
                            borderStyle: 'solid',
                            borderColor: '#dddddd',
                        }}
                    >
                        <Tabs
                            value={hideTabs ? 3 : chatRoom}
                            onChange={this.handleChange}
                            // variant="standard"
                            variant={!isDoctorOrNurse ? 'standard' : 'fullWidth'}
                            centered
                            indicatorColor="secondary"
                            textColor="secondary"
                            className={`${hideTabs ? classes.hideTabs : ''}`}
                        >
                            <TabContainerC
                                label="CHATROOM"
                                icon={
                                    <Badge
                                        className={style.customBadge}
                                        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                                        // overlap="circle"
                                        badgeContent={this.props.unreadCounts.chatRoom}
                                        invisible={
                                            this.state.chatRoom === 0 || this.props.unreadCounts.chatRoom === 0
                                        }
                                    >
                                        <ChatIcon style={{ fontSize: 'large' }} />
                                    </Badge>
                                }
                            />
                            <Tab
                                label="IPR/ATT PLAN"
                                icon={<CollectionsBookmarkIcon />}
                                disabled={true}
                                style={{ minWidth: '40px', fontSize: 'xx-small', color: '#eee', display: 'none' }}
                            />
                            <Tab
                                label="ANALYSIS"
                                icon={<AssessmentIcon />}
                                disabled={true}
                                style={{ minWidth: '40px', fontSize: 'xx-small', color: '#eee', display: 'none' }}
                            />
                            {!isDoctorOrNurse ? (
                                <TabContainerC
                                    label="DISTR CHAT"
                                    icon={
                                        <Badge
                                            className={style.customBadge}
                                            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                                            // overlap="circle"
                                            badgeContent={this.props.unreadCounts.privateChat}
                                            invisible={
                                                this.state.chatRoom === 3 ||
                                                this.props.unreadCounts.privateChat === 0
                                            }
                                        >
                                            <LockIcon style={{ fontSize: 'large' }} />
                                        </Badge>
                                    }
                                />
                            ) : (
                                ''
                            )}
                            {['ADMIN', 'SADMIN'].includes(this.state.currentUserRole) ? (
                                <TabContainerC
                                    label="INTL CHAT"
                                    icon={
                                        <Badge
                                            className={style.customBadge}
                                            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                                            // overlap="circle"
                                            badgeContent={this.props.unreadCounts.intlChat}
                                            invisible={
                                                this.state.chatRoom === 4 || this.props.unreadCounts.intlChat === 0
                                            }
                                        >
                                            <LockIcon style={{ fontSize: 'large' }} />
                                        </Badge>
                                    }
                                />
                            ) : (
                                ''
                            )}
                        </Tabs>
                    </AppBar>
                        {chatRoom === 0 && (
                            <TabContainer>
                                <DragAndDrop
                                    style={{ width: '100%' }}
                                    handleDrop={
                                        // {this.handleDrop}
                                        !isDoctorOrNurse ? null : this.handleDrop
                                    }
                                >
                                    <div
                                        className="msgroom"
                                        onPaste={(e) => this.handleOnPaste(e)}
                                        style={{
                                            height: this.smileDesignChatBoxHeight(hideTabs),
                                            minHeight: 350,
                                        }}
                                        ref={this.msgContainer}
                                    >
                                        <Grid container>
                                            {this.props.loadingMessages ? (
                                                <div
                                                    style={{
                                                        position: 'absolute',
                                                        left: '50%',
                                                        top: '50%',
                                                        transform: 'translate(-50%, -50%)',
                                                    }}
                                                >
                                                    <CircularProgress className={classes.progress} color="secondary" />
                                                </div>
                                            ) : (
                                                this.setMessage(this.props.chatRoomMessages)
                                            )}
                                        </Grid>
                                    </div>
                                </DragAndDrop>
                            </TabContainer>
                        )}
                        {chatRoom === 1 && <TabContainer>Item Two</TabContainer>}
                        {chatRoom === 2 && <TabContainer>Item Three</TabContainer>}
                        {chatRoom === 3 && (
                            <TabContainer>
                                <DragAndDrop style={{ width: '100%' }} handleDrop={this.handleDrop}>
                                    <div
                                        className="msgroom"
                                        onPaste={(e) => this.handleOnPaste(e)}
                                        style={{
                                            height: this.smileDesignChatBoxHeight(hideTabs),
                                            // maxHeight: '65vh',
                                            minHeight: 350,
                                        }}
                                        ref={this.msgContainer}
                                    >
                                        <Grid container>
                                            {this.props.loadingMessages ? (
                                                <div
                                                    style={{
                                                        position: 'absolute',
                                                        left: '50%',
                                                        top: '50%',
                                                        transform: 'translate(-50%, -50%)',
                                                    }}
                                                >
                                                    <CircularProgress className={classes.progress} color="secondary" />
                                                </div>
                                            ) : (
                                                this.setMessage(this.props.privateChatMessages)
                                            )}
                                        </Grid>
                                    </div>
                                </DragAndDrop>
                            </TabContainer>
                        )}
                        {chatRoom === 4 && (
                            <TabContainer>
                                <DragAndDrop style={{ width: '100%' }} handleDrop={this.handleDrop}>
                                    <div
                                        className="msgroom"
                                        onPaste={(e) => this.handleOnPaste(e)}
                                        style={{
                                            height: this.smileDesignChatBoxHeight(hideTabs),
                                            // maxHeight: '65vh',
                                            minHeight: 350,
                                        }}
                                        ref={this.msgContainer}
                                    >
                                        <Grid container>
                                            {this.props.loadingMessages ? (
                                                <div
                                                    style={{
                                                        position: 'absolute',
                                                        left: '50%',
                                                        top: '50%',
                                                        transform: 'translate(-50%, -50%)',
                                                    }}
                                                >
                                                    <CircularProgress className={classes.progress} color="secondary" />
                                                </div>
                                            ) : (
                                                this.setMessage(this.props.intlChatMessages)
                                            )}
                                        </Grid>
                                    </div>
                                </DragAndDrop>
                            </TabContainer>
                        )}
                    </div>
                    {/* Tabs End */}
                    {['ADMIN', 'SADMIN'].includes(this.state.currentUserRole) && this.state.chatRoom === 0 ? (
                        this.state.chatRoom === 0 && this.props.unreadCounts.chatRoom !== 0 && (
                            <Grid
                                container
                                style={{ padding: '4px 8px 8px 8px', backgroundColor: '#f0f0f0ad', marginTop: '32px !important' }}
                                className={classes.alignToBottom && `${exitFullScreen ? classes.exitFullScreen : ''}`}
                            >
                                <Grid item xs={12} style={{ display: 'inline-flex' }}>
                                    {this.createMarkAsRead(this.props.unreadCounts.chatRoom)}
                                </Grid>
                            </Grid>
                        )
                    ) : (
                        <Grid container style={{ padding: "4px 0px", backgroundColor: '#f0f0f0ad' }}>
                            <Box style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
                                <div className={style.uploadBtnWrapper}>
                                    <IconButton
                                        component="label"
                                        style={{ padding: '6px' }} // 6px padding for the 14px small variant we made earlier
                                    >
                                        <AttachFileIcon style={{ fontSize: 22 }} />
                                        <input
                                            type="file"
                                            name="photo_section"
                                            hidden
                                            onChange={(event) => this.fileupload(event.target.files[0])}
                                        />
                                    </IconButton>
                                </div>
                                <IconButton style={{ padding: '6px' }} onClick={() => this.changeFontSize()}>
                                    <FormatSizeIcon style={{ fontSize: 22 }} />
                                </IconButton>
                                {this.state.chatRoom === 0 && this.props.unreadCounts.chatRoom !== 0
                                    ? this.createMarkAsRead(this.props.unreadCounts.chatRoom)
                                    : ''}
                                {this.state.chatRoom === 3 && this.props.unreadCounts.privateChat !== 0
                                    ? this.createMarkAsRead(this.props.unreadCounts.privateChat)
                                    : ''}
                                {this.state.chatRoom === 4 && this.props.unreadCounts.intlChat !== 0
                                    ? this.createMarkAsRead(this.props.unreadCounts.intlChat)
                                    : ''}
                            </Box>
                            <Grid item xs={12} style={{ display: 'inline-flex', padding: '0 6px' }}>
                                <Input
                                    id="text"
                                    type="text"
                                    multiline
                                    onChange={(e) => {
                                        this.setState({ message: e.target.value });
                                        this.props.setDraftChatMessage({
                                            type: this.state.chatRoom,
                                            msg: e.target.value,
                                        });
                                    }}
                                    onKeyPress={(e) => this.handleMsgInputKeypress(e)}
                                    placeholder={this.get('clinicalSimulation.chat.sendPlaceHolder')}
                                    value={this.state.message}
                                    style={{ width: '100%' }}
                                    inputProps={{ style: { fontSize: 14 } }}
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label="Send message"
                                                style={{ fontSize: 22, padding: '6px' }}
                                                onClick={(e) => this.handleSentButtonClick(e)}
                                            >
                                                <SendIcon />
                                            </IconButton>
                                        </InputAdornment>
                                    }
                                />
                            </Grid>
                        </Grid>
                    )}
                </div>
            </Grid>
        );
    }
}

const mapStateToProps = (store) => ({
    lang: store.lang,
    smileDesign: store.smileDesign,
    clinicalSimulation: store.clinicalSimulation,
    unreadCounts: store.clinicalSimulation.unreadCounts,
});

const mapDispatchToProps = (dispatch) => ({
    enqueueSnackbar: (msg, variant) => dispatch(easySnackbar(msg, variant, true)),
    openModal: (value) =>
        dispatch(
            openModal({
                modalTitle: value.title,
                modalMessage: value.message,
                modalCallbackFunc: value.modalCallbackFunc,
                modalOnCloseCallbackFunc: value.modalOnCloseCallbackFunc,
                showOk: value.showOk,
            })
        ),
    updateDeletableMsgMap: (value) => dispatch(setDeletableMsgMap(value)),
    clearDeletableMsgMap: () => dispatch(resetDeletableMsgMap()),
    setDraftChatMessage: (value) => dispatch(setDraftChatMessage(value)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(withRouter(withLang(Chat, 'PatientInfo'))));
